

<template>
    <div>
        <h1 class="font-bold my-10">
            {{ $t('nav.contact') }}
        </h1>
        <p v-html="contact">
            
        </p>
    </div>
</template>

<script>
import api from '@/api';

export default {
    name: 'contact',
    components: {
    },
    data(){
        return {
            loading: false,
            contact: []
        }
    },
    methods: {
        async getContact(){
            this.loading = true
            try{ 
                const response = await api.get('info/')
                this.contact = response.data['contacts']
            }
            catch(e){
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {

    },
    created(){
         this.getContact()
    }
}
</script>